import { useCallback } from "react";
import { debounce } from "lodash";

// https://divyanshu013.dev/blog/react-debounce-throttle-hooks/

export function useDebounce(callback: any, delay: number) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(
    debounce((...args) => callback(...args), delay),
    [delay] // will recreate if delay changes
  );
}
